import { IApplicationState, VSConfiguration } from '@bees-web/core/types'
import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useInteractiveMap } from './useInteractiveMap'
import { useValueStream } from './useValueStream'

export type UseWorkspaceResult = {
  interactiveMap: Record<string, unknown>
  workspaceState: IApplicationState
}

export const useWorkspace = (
  workspace: VSConfiguration,
  dependencies?: VSConfiguration[]
): UseWorkspaceResult => {
  const dispatch = useDispatch()

  const { createInteractiveMap, stateSelector } = useValueStream(
    workspace,
    dependencies
  )

  const workspaceState = useSelector(stateSelector)

  const interactiveMap = useInteractiveMap(
    createInteractiveMap,
    dispatch,
    workspaceState
  )

  return useMemo(
    () => ({
      interactiveMap,
      workspaceState,
    }),
    [interactiveMap, workspaceState]
  )
}

export default useWorkspace
